import { render, staticRenderFns } from "./SetupSession.vue?vue&type=template&id=26f7b774&scoped=true"
import script from "./SetupSession.vue?vue&type=script&lang=ts"
export * from "./SetupSession.vue?vue&type=script&lang=ts"
import style0 from "./SetupSession.vue?vue&type=style&index=0&id=26f7b774&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f7b774",
  null
  
)

export default component.exports